import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { Observable } from "rxjs/internal/Observable";
import { ExceptionHandler } from "./errorhandler";
import { catchError } from "rxjs/operators";
import { TblCourses } from "../models/courses";
import { CommonHeader } from "./common-header";
import { LocalStorageService } from "src/app/utility/localStorageService";

@Injectable({
  providedIn: "root",
})
export class CoursesService {
  deleteCourseById(refNo: string): Observable<any> {
    this.localStorage.set("method","Delete")
    this.localStorage.set("operation","Get Course By Id")
    const endPoint = `${this.serviceRoot}/deleteCourseById/${refNo}`;
    return this.http.get<any>(endPoint,  this.options).pipe(catchError(this.ehandler.errorHandler));
  }
  private serviceRoot = `${environment.serviceRoot}`;
  commonHeader:CommonHeader=new CommonHeader() 
  private options=this.commonHeader.options;
  constructor(
    private http: HttpClient,
    private ehandler:ExceptionHandler,
    private localStorage:LocalStorageService
  ) { }

  getAllCourses(): Observable<any[]> {
    this.localStorage.set("method","Read")
    this.localStorage.set("operation","Get All Course")
    const endPoint = `${this.serviceRoot}/getAllCourses`;
    return this.http.get<any[]>(endPoint, this.options)
    .pipe(catchError(this.ehandler.errorHandler));
  }

  getCoursesById(id:number): Observable<TblCourses> {
    this.localStorage.set("method","Read")
    this.localStorage.set("operation","Get Course By Id")
    const endPoint = `${this.serviceRoot}/getCoursesById/${id}`;
    return this.http.get<TblCourses>(endPoint,  this.options).pipe(catchError(this.ehandler.errorHandler));
  }

  saveAndUpdateCourses(data:TblCourses):Observable<any>{
    this.localStorage.set("method","Save/Update")
    this.localStorage.set("operation","Save/Update Course")
    const endPoint = `${this.serviceRoot}/saveCourses`;
    console.log("Data="+JSON.stringify(data))
    return this.http.post<any>(endPoint, data,this.options).pipe(catchError(this.ehandler.errorHandler));
  }

}
